import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/Transformation.jpg"


export const Transformation = () => {    

    return (
        <SongLinks 
        title={"Transformation"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/23FYzlYTGIOaE3bRQXvdDA"}
        spotifyPresaveLink={"https://add-it.feiyr.com/MondWild/Transformation"}
        appleMusicLink={"https://music.apple.com/de/album/transformation-single/6791588527"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=U76TUVBaFGU"}
        youtubeLink={"https://youtu.be/jEjRbKYWCjg"}
        tidalLink={"https://tidal.com/track/543681301"}
        amazonMusicLink={"https://www.amazon.de/music/player/albums/B0H952Z2QK"}
        bandcampLink={"https://mondwild.bandcamp.com/track/transformation"}
        releaseDate={"2026-08-14T00:00:00+02:00"}/>
    );
}